
import React from 'react';
import * as Styled from './styles.module';
import { Spinner } from '../../../components/UIKitComponents/Spinner/Spinner';


interface IMessageItemImageProps {
    src : string;
}

type Props =  IMessageItemImageProps;

export class MessageItemImage extends React.Component<Props> {

  state : any = {
    imageLoading : true
  }

  handleImageLoaded() {
    this.setState({
        imageLoading : false
    });
  }

  render() {
    return (
        <Styled.ImageWrap>
            { this.state.imageLoading ? <Spinner fit color="#3333cc" size={10}  /> : '' }
            <a href={this.props.src} target='_blank'>
                <Styled.Image src={this.props.src} onLoad={() => this.handleImageLoaded()} />
            </a>
        </Styled.ImageWrap>
    );
  }
}
